import moment from 'moment'

export const modelOfDelivery = {
    id: '',
    name: '',
    createdBy: '',
    updatedBy: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}